<template>
  <div>
    <header-authenticate></header-authenticate>
    <div class="container">
      <div class="home profile">
        <div class="profile__container-image">
          <div class="profile__container-image__photo">
            <template v-if="this.profile.picture && this.profile.picture != ''">
              <img :src="getUrlProfile()">
            </template>
            <template v-else>
              <h3>{{getName()}}</h3>
            </template>
          </div>
          <label v-if="isApp">
            <div class="profile__container-image__icon" @click="captureImage()">
              <img src="@/assets/edit.svg">
            </div>
          </label>
          <label v-else for="image-profile">
            <input type="file" id="image-profile" style="display:none" @change="openModalPreviewImageProfile($event)" accept='image/x-png,image/gif,image/jpeg'>
            <div class="profile__container-image__icon">
              <img src="@/assets/edit.svg">
            </div>
          </label>
        </div>
        <div class="form-group">
          <input 
          type="text"
          v-model.trim="$v.profile.firstName.$model"
          :class="{'has-error': $v.profile.firstName.$error && $v.profile.firstName.$invalid, 'with-value': $v.profile.firstName.$model != ''}"
          :id="$t('profile.form.firstName')" class="form-control" required>
          <label class="form-control-placeholder" :for="$t('profile.form.firstName')">{{$t('profile.form.firstName')}}</label>
        </div>
        <div class="form-group">
          <input 
          type="text"
          v-model.trim="$v.profile.lastName.$model"
          :class="{'has-error': $v.profile.lastName.$error && $v.profile.lastName.$invalid, 'with-value': $v.profile.lastName.$model != ''}"
          :id="$t('profile.form.lastName')" class="form-control" required>
          <label class="form-control-placeholder" :for="$t('profile.form.lastName')">{{$t('profile.form.lastName')}}</label>
        </div>
        <div class="form-group">
          <!-- Mobile datepicker -->
          <template v-if="isMobile && formatDate">
            <input
            type="date"
            v-model.trim="$v.profile.birthDate.$model"
            :class="{'has-error': $v.profile.birthDate.$error && $v.profile.birthDate.$invalid}"
            :id="$t('profile.form.birthDate')" class="form-control with-value" required/>
            <label class="form-control-placeholder" :for="$t('profile.form.birthDate')">{{$t('profile.form.birthDate')}}</label>
          </template>
          <!-- Desktop datepicker -->
          <template v-if="!isMobile && formatDate">
            <datepicker
            v-model.trim="$v.profile.birthDate.$model"
            :class="{'has-error': $v.profile.birthDate.$error && $v.profile.birthDate.$invalid}"
            :id="$t('profile.form.birthDate')" class="form-control with-value" required
            :format="'dd/MM/yyyy'" :language="language[language.localLanguage]"></datepicker>
            <label class="form-control-placeholder" :for="$t('profile.form.birthDate')">{{$t('profile.form.birthDate')}}</label>
          </template>
        </div>
        <div class="form-group">
          <select v-model.trim="$v.profile.teamId.$model" :class="{'has-error': $v.profile.teamId.$error && $v.profile.teamId.$invalid}">
            <option disabled value="">{{$t('profile.form.team')}}</option>
            <option v-for="(team, idxTeam) in teams" :key="idxTeam" :value="team.id">{{team.name}}</option>
          </select>
        </div>
        
        <button class="button button--white" @click="saveProfile()" :disabled="$v.profile.$invalid || submitted">
          <template v-if="!submitted">
            {{$t('profile.save')}}
          </template>
          <template v-else>
            {{$t('profile.loading')}} <div class="loading-points"><span>.</span><span>.</span><span>.</span></div>
          </template>
        </button>
        <button class="button button--clean" @click="singOff()">{{$t('profile.signoff')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderAuthenticate from '@/components/Header/Authenticate.vue'
import { mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import persistentData from '@/plugins/persistentData'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import { en, es } from 'vuejs-datepicker/dist/locale'


export default {
  components: {
    HeaderAuthenticate,
    Datepicker
  },
  computed: {
    ...mapState({
      profile: state => state.ProfileModule.profile,
      teams: state => state.InfoModule.teams
    }),
    isApp(){
      return window["cordova"] != undefined;
    }
  },
  data() {
    return {
      loadingPictureProfile: false,
      submitted: false,
      formatDate: false,
      language: {
        localLanguage: persistentData.getData('language').toLowerCase(),
        en: en,
        es: es
      },
      isMobile: (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone|Opera Mini/i.test(navigator.userAgent))
    }
  },
  mounted() {
    if (Object.keys(this.profile).length == 0) {
      this.$store.dispatch('profileGet').then(() => this.formatBirthDate())
    } else {
      this.formatBirthDate()
    }
    if (this.teams.length == 0) this.$store.dispatch('getTeams')   
  },
  methods: {
    async saveProfile(){
      this.submitted = true
      const request = await this.$store.dispatch('profileUpdate', this.$v.profile.$model)
      if (request.status == 200) {
        this.submitted = false
        this.$store.dispatch('addNotification', {
          value: this.$t('notifications.updateProfile'),
          status: "success",
          remove: true
        })
      }
    },
    captureImage() {
			let cameraConfig = {
				quality: 50,
				sourceType: 1,
				destinationType: navigator.camera.DestinationType.DATA_URL,
				encodingType: navigator.camera.EncodingType.JPEG,
				mediaType: navigator.camera.MediaType.PICTURE,
        cameraDirection: navigator.camera.Direction.BACK,
        correctOrientation : true
      };
      this.$store.dispatch("addNotification", {
        value: this.$t('notifications.loadingCamera'),
        status: 'success',
        remove: false
      })
			navigator.camera.getPicture(
        data => { this.processPicture(data)
        setTimeout(() => {
            this.$store.dispatch('removeNotification', 0)
            window.StatusBar.hide();
            window.StatusBar.show();
        }, 100)
        },
        error => { console.log(error) 
        setTimeout(() => {
            this.$store.dispatch('removeNotification', 0)
            window.StatusBar.hide();
            window.StatusBar.show();
        }, 100)},
				cameraConfig
			)
    },
    async processPicture (path) {
      this.openModalPreviewImageProfile({ target : { files : [ this.dataURLtoBlob(path, 'image/jpg')] } } )
    },
    dataURLtoBlob (b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: contentType});
      blob['name'] = `profile${new Date().getTime()}.jpg`;
      blob['lastModified'] = new Date();
      return blob;
    },   
    async openModalPreviewImageProfile (event) {
      const file = event.target.files[0]
      console.log(file)
      
      if(!file || !file.type.includes("image") ) {
        return false
      }

      this.$store.dispatch("openModalCropImageProfile")
      this.$store.dispatch("imageModalCropImageProfile", file)
    },
    singOff() {
      persistentData.removeData('fullName')
      persistentData.removeData('token')
      persistentData.removeData('tokenExpiration')
      this.$router.push('/welcome')
    },
    getUrlProfile() {
      if (this.profile.picture) {
        return `${process.env.VUE_APP_CDN_URL_USER}${this.profile.picture}`
      }
    },
    getName() {
      if (this.profile.firstName && this.profile.lastName) {
        return `${this.profile.firstName.charAt(0)}${this.profile.lastName.charAt(0)}`
      }
    },
    formatBirthDate() {
      this.$v.profile.birthDate.$model = moment(this.$v.profile.birthDate.$model).format('YYYY-MM-DD')
      this.formatDate = true
    }
  },
  validations: {
    profile: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      birthDate: {
        required
      },
      teamId: {
        required
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.profile {
  padding: 80px $margin-base;
}

.profile__container-image {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin-bottom: $margin-milli;
  position: relative;

  &__photo {
    width: 80px;
    height: 80px;
    background: $white;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    h3 {
      font-size: map-get($fontSizes, giga);
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  
  &__icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
    position: absolute;
    bottom: 0;
  }
}
</style>